{
  "title": "Caisses",
  "subtitle": "Les caisses de chaque magasin, le navigateur de chacune, et leurs services.",
  "status": {
    "open": "Ouvert",
    "pendingApproval": "Écart à approuver",
    "closed": "Fermé"
  },
  "count": {
    "dinars": "{{value}} TND",
    "millimes": "{{value}} millimes",
    "quantityOf": "Combien de {{name}}",
    "total": "Total compté",
    "empty": "Rien de compté."
  },
  "device": {
    "is": "Ce navigateur est {{name}} · {{store}}",
    "shiftOpen": "Service de {{cashier}}, ouvert depuis {{time}}.",
    "noShift": "Aucun service ouvert : comptez le fond de caisse pour en ouvrir un.",
    "none": "Ce navigateur n’est pas une caisse",
    "noneManager": "Associez-le à l’une des caisses ci-dessous pour encaisser au comptoir.",
    "noneHint": "Un responsable associe le navigateur du comptoir à sa caisse.",
    "goToShift": "Aller au service",
    "open": "Ouvrir le service",
    "pos": "Ouvrir la caisse"
  },
  "list": {
    "add": "Ajouter une caisse",
    "shifts": "Services",
    "inactive": "Hors service",
    "thisBrowser": "Ce navigateur",
    "nextReceipt": "Prochain ticket",
    "device": "Sur {{label}} · associée le {{date}} par {{by}}",
    "noDevice": "Aucun navigateur associé",
    "shiftOpen": "Service de {{cashier}} ouvert depuis {{time}}",
    "left": "{{amount}} laissés dans le tiroir",
    "neverOpened": "Jamais ouverte",
    "actions": "Actions sur {{name}}",
    "edit": "Modifier"
  },
  "empty": {
    "title": "Aucune caisse pour l’instant",
    "text": "Ajoutez une caisse par comptoir de vos magasins : elle numérote ses tickets et ses rapports Z."
  },
  "edit": {
    "newTitle": "Nouvelle caisse",
    "title": "Modifier {{name}}",
    "hint": "Une caisse appartient à un magasin ; son préfixe numérote ses tickets et ses rapports Z.",
    "name": "Nom",
    "namePlaceholder": "Comptoir 1",
    "store": "Magasin",
    "prefix": "Préfixe des tickets",
    "prefixHint": "2 à 6 lettres, utilisées par aucun autre document.",
    "active": "En service",
    "activeHint": "Hors service, elle n’est plus la caisse d’aucun navigateur et n’ouvre aucun service.",
    "create": "Ajouter la caisse",
    "created": "{{name}} ajoutée",
    "saved": "{{name}} enregistrée"
  },
  "pair": {
    "action": "Associer ce navigateur",
    "undo": "Dissocier",
    "title": "Faire de ce navigateur {{name}}",
    "hint": "L’argent encaissé sur ce navigateur ira dans le service ouvert de la caisse.",
    "replaces": "{{label}} est cette caisse aujourd’hui : il ne le sera plus. Une caisse fonctionne sur un seul navigateur à la fois.",
    "label": "Quel est ce navigateur ?",
    "labelHint": "Pour reconnaître l’appareil dans la liste.",
    "labelPlaceholder": "PC du comptoir",
    "confirm": "Associer ce navigateur",
    "done": "Ce navigateur est maintenant {{name}}",
    "undone": "{{name}} n’est plus la caisse d’aucun navigateur"
  },
  "open": {
    "title": "Ouvrir le service de {{register}}",
    "hint": "Comptez le fond de caisse billet par billet et pièce par pièce.",
    "count": "Fond de caisse dans le tiroir",
    "left": "Le service précédent a laissé {{amount}} dans le tiroir.",
    "difference": "Différence :",
    "note": "Note",
    "confirm": "Ouvrir avec {{amount}}",
    "done": "Service ouvert à {{register}}"
  },
  "movement": {
    "title": "Espèces entrées ou sorties du tiroir",
    "type": "Mouvement",
    "types": {
      "payIn": "Entrée",
      "payOut": "Sortie",
      "drop": "Dépôt au coffre"
    },
    "hints": {
      "payIn": "Argent mis dans le tiroir (monnaie de la banque). Dites d’où il vient.",
      "payOut": "Argent sorti du tiroir (un petit achat). Dites pourquoi.",
      "drop": "Argent porté au coffre pendant le service, pour alléger le tiroir."
    },
    "amount": "Montant",
    "reason": "Motif",
    "confirm": {
      "payIn": "Enregistrer l’entrée",
      "payOut": "Enregistrer la sortie",
      "drop": "Enregistrer le dépôt"
    },
    "done": {
      "payIn": "{{amount}} mis dans le tiroir",
      "payOut": "{{amount}} sortis du tiroir",
      "drop": "{{amount}} portés au coffre"
    }
  },
  "close": {
    "title": "Fermer le service de {{register}}",
    "hint": "Comptez le tiroir ; les espèces attendues s’affichent pendant le comptage.",
    "blindHint": "Comptez le tiroir : les espèces attendues s’affichent une fois le comptage saisi (comptage à l’aveugle).",
    "count": "Espèces dans le tiroir",
    "expectedNow": "Attendu maintenant : {{amount}}",
    "kept": "Laissé dans le tiroir",
    "keptHint": "Pour le service suivant. {{amount}} vont au coffre.",
    "note": "Note",
    "limit": "Un écart de plus de {{amount}} attend l’approbation d’un responsable.",
    "confirm": "Fermer le service",
    "counted": "Compté",
    "expected": "Attendu",
    "variance": "Écart",
    "toSafe": "Au coffre",
    "closedTitle": "Service fermé",
    "closedText": "Le rapport Z {{number}} est émis.",
    "pendingTitle": "Service fermé, écart à approuver",
    "pendingText": "L’écart dépasse la limite : un responsable l’approuve, puis le rapport Z est émis.",
    "ok": "Terminé"
  },
  "approve": {
    "action": "Approuver l’écart",
    "title": "Approuver l’écart",
    "text": "Le comptage de {{cashier}} diffère des espèces attendues. Dites ce que vous avez vérifié.",
    "note": "Pourquoi il est accepté",
    "confirm": "Approuver et émettre le rapport Z",
    "done": "Écart approuvé, rapport Z {{number}} émis"
  },
  "figures": {
    "xTitle": "Rapport X",
    "closedTitle": "Chiffres à la fermeture",
    "method": "Moyen",
    "count": "Paiements",
    "received": "Reçu",
    "refunded": "Remboursé",
    "net": "Net",
    "none": "Aucun paiement dans ce service pour l’instant.",
    "float": "Fond de caisse",
    "expected": "Espèces attendues",
    "blind": "Affiché après le comptage"
  },
  "movements": {
    "title": "Mouvements d’espèces",
    "hint": "Entrées, sorties et dépôts au coffre.",
    "none": "Aucun mouvement."
  },
  "shift": {
    "opened": "Ouvert le {{time}}",
    "closed": "Fermé le {{time}}",
    "printX": "Imprimer le rapport X",
    "close": "Fermer le service",
    "zReport": "Rapport Z",
    "pendingTitle": "L’écart attend un responsable",
    "pendingText": "Le comptage est saisi. Un responsable approuve l’écart, puis le rapport Z est émis.",
    "pendingManager": "Vérifiez le comptage, puis approuvez l’écart pour émettre le rapport Z.",
    "blind": "Comptage à l’aveugle : les espèces attendues s’affichent une fois le tiroir compté.",
    "opening": "Ouverture",
    "left": "Laissé par le service précédent",
    "openingDifference": "Différence à l’ouverture",
    "closing": "Fermeture",
    "closedBy": "Compté par {{name}}",
    "approvedBy": "Approuvé par {{name}}"
  },
  "shifts": {
    "title": "Services",
    "subtitleAll": "Tous les services des caisses de vos magasins, les plus récents d’abord.",
    "subtitleOwn": "Vos services, les plus récents d’abord.",
    "register": "Caisse",
    "allRegisters": "Toutes les caisses",
    "status": "Statut",
    "allStatuses": "Tous les statuts",
    "empty": "Aucun service pour l’instant",
    "emptyText": "Les services apparaissent ici dès qu’un caissier en ouvre un à une caisse.",
    "columns": {
      "register": "Caisse",
      "cashier": "Caissier",
      "opened": "Ouvert",
      "status": "Statut",
      "counted": "Compté (TND)",
      "variance": "Écart (TND)"
    },
    "more": "Voir plus"
  },
  "z": {
    "immutable": "Un rapport Z est émis une fois et ne change jamais.",
    "print": "Imprimer",
    "title": "Rapport Z",
    "taxId": "Matricule fiscal",
    "register": "Caisse",
    "cashier": "Caissier",
    "opened": "Ouvert",
    "closed": "Fermé",
    "sales": "Paiements par moyen",
    "drawer": "Tiroir",
    "closedBy": "Compté et fermé par {{name}}.",
    "approvedBy": "Écart approuvé par {{name}} le {{date}}",
    "amountsIn": "Montants en dinars tunisiens (TND).",
    "issued": "Émis le {{date}}."
  },
  "till": {
    "into": "Encaissé à {{name}} : va dans le service de {{cashier}}.",
    "closedTitle": "Ce navigateur est {{name}} et son service n’est pas ouvert",
    "closedText": "L’argent encaissé à une caisse va dans son service ouvert.",
    "open": "Ouvrir le service"
  }
}
